import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { IOlaylar, OlaylarFilter } from '@models/dashboard';
import { DashboardService } from '@services/apis/dashboard.service';
import { RootModalComponent } from '@shared/components/root-modal/root-modal.component';
import { format } from 'date-fns';
import { EventsFilterComponent } from '../events-filter/events-filter.component';
@Component({
  selector: 'app-events-list',
  templateUrl: './events-list.component.html',
  styleUrls: ['./events-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class EventsListComponent implements OnInit {
  public olaylar: IOlaylar[];
  public tumOlaylar: IOlaylar[];
  public olayFilter: OlaylarFilter

  constructor(
    private dashboardService: DashboardService,
    private routerOutlet: IonRouterOutlet,
    private modalController: ModalController,
  ) {
    this.olayFilter = new OlaylarFilter();
   }

  ngOnInit(): void {
    this.getEvents();
  }

  async getEvents() {
    this.dashboardService.getOlaylar$().subscribe(response => {
      this.olaylar = response;
      this.tumOlaylar = this.olaylar;
    });
  }

  changeDate() {
    const _tarih = format(new Date(this.olayFilter.tarih), 'dd.MM.yyyy');
    this.olaylar = this.tumOlaylar.filter((x) => format(new Date(x.olayTarihi), 'dd.MM.yyyy') === _tarih);
    console.log(_tarih);
  }

  async filter() {
    const modal = await this.modalController.create({
      component: RootModalComponent,
      swipeToClose: false,
      presentingElement: this.routerOutlet.nativeEl,
      componentProps: {
        rootPage: EventsFilterComponent,
        olayFilter: this.olayFilter
      }
    });
    modal.onDidDismiss().then(async (dismissResult) => {
      const selectedData = dismissResult.data;
      if (selectedData.dismissed) {
        if (selectedData.olayTurID > 0) {
          this.olaylar = this.tumOlaylar.filter((x) => x.olayTurID === selectedData.olayTurID);
        } else {
          this.olaylar = this.tumOlaylar;
        }
      }
    });
    return await modal.present();
  }

}
